import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { PaginationService } from '../../../PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { qmsService } from '../../qms.service';
import { CodeList } from 'src/app/add-training/codeList';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AuService } from '../../au/au.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-parallel-workflow-detail',
  templateUrl: './parallel-workflow-detail.component.html',
  styleUrls: ['./parallel-workflow-detail.component.scss']
})
export class ParallelWorkflowDetailComponent implements OnInit {
  isProcessing = false;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  oneQmsOrgUsersDetails: any;
  searchText: any;
  isAdenabled = false;
  codelistGroupList: any = [];
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  oneQmsUsersDataForFilter !: any[];
  dropDownDataForModule: any = [];
  makeStickyColumns: any;
  parallelWorkflowData: any = {};
  showstageUsers: boolean = false;
  onTabChanged($event: any) {
    console.log();
  }

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef,
    public qmsservice: qmsService, public auService: AuService, private readonly authService: MsalService) { };

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: 'QMS_PARALLEL_WORKFLOWS_VW',
      moduleName: this.qmsservice.moduleName,
      gridName: 'PARALLEL_WORKFLOWS',
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error
      }
    });
  }

  tempauditStatus: any = '';
  orgData: any;

  ngOnInit(): void {
    this.tempauditStatus = this.qmsservice.activity.status ?? this.tempauditStatus;
    this.showstageUsers = false;
    this.appService.getWorkflowByWorkflowId(this.qmsservice.workflowId).subscribe((data: any) => {
      this.parallelWorkflowData = data[0];
      this.qmsservice.parallelworkflowStatus = data[0].status;
      this.showstageUsers = true;
      this.buttongetCall();
    });
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })
    const field = document.getElementById('justification-validation') as HTMLInputElement;
    field.style.color = '#005c8a'

    this.labelcall();
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    if (field != null)
      field.style.color = (selectedItems === null || selectedItems == '') && field ? 'red' : '#005c8a';
  }

  editworkflowDetail() {
    if (this.parallelWorkflowData.reasonForWorkflow == '') {
      this.handleDropDownValidation('justification-validation', this.parallelWorkflowData.reasonForWorkflow);
      this.showSnackBar("Please enter justification for parallel workflow", "E");
    } else {
      this.isProcessing = true;

      delete this.parallelWorkflowData.createdOn;
      delete this.parallelWorkflowData.updatedOn;
      delete this.parallelWorkflowData.lastActionOn;


      this.appService.updateParallelWorkflow(this.parallelWorkflowData).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  };

  buttonLabels: any;
  noteResult: any;
  showsavebtn: boolean = false;
  stageName: any;
  actionStatusOptions: any;
  instructions: any;
  buttongetCall() {
    this.buttonLabels = [];
    const obj = {
      workflowId: this.qmsservice.workflowId,
      currentStatus: this.parallelWorkflowData.status
    }

    this.appService.getWorkflowButtons(obj).subscribe((data: any) => {

      this.qmsservice.activitySaveButton = false;
      this.qmsservice.activityDynamicButtonList = [];
      this.buttonLabels = [];

      if (data.resultType == "S") {
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusLabel;
        this.instructions = data.instructions;
        this.qmsservice.activityButtonLabels = data;
        if (data.buttonLabels) {
          this.buttonLabels = data.buttonLabels.split(",");

          for (const element of this.buttonLabels) {
            if (element == "Save") {
              this.showsavebtn = true;
            }
          }
        } else {
          this.buttonLabels.push("Cancel");
        }
      } else {
        this.buttonLabels = data.buttonLabels.split(",");
      }

      if (data.resultType != "S") {
        this.showSnackBar(data.result, data.resultType);
      }
    })
  }

  //finding dynamic btn
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = "";
  reviewStatus: any;
  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  selectedStatus: any = null;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;
  dynamicButtonClick(button: any) {
    this.buttonLabel = button;

    if (button == "Review Response") {
      this.reviewStatus = ['Reviewed', 'Review Rejected'];
    } else if (button == "Approve") {
      this.reviewStatus = ['Approved', 'Approval Rejected'];
    } else if (button == "Verify Response") {

      this.reviewStatus = ['Accept Response', 'Response Verification Rejected', 'Accept Response/No Implementation Required'];

    } else if (button == "Verify Implementation") {
      this.reviewStatus = ['Accept Implementation', 'Implementation Verification Rejected'];
    } else if (button == "Review Implementation") {
      this.reviewStatus = ['Reviewed', 'Review Rejected'];
    }

    this.selectedStatus = null;
    this.reason = "";
    this.password = "";

    this.userName = localStorage.getItem("loggedUserName");

    this.isEsignRequired = false;
    this.isReasonSignReqd = true;
    this.isEsignRequired = true;
    this.changetypeAddAndEditPassword = true;
    if (button.length > 30) {
      this.confirmWithReasonPopupConfig.width = '650px';
    } else {
      this.confirmWithReasonPopupConfig.width = '500px';
    }
    this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
  }
  radioChange(event: any) {
    console.log(event.value);
    if (this.reviewAndapproveToggleValue != undefined) {
      this.reviewAndapproveToggleValue.style.color = '';
    }
  }

  onPasswordFieldFocusout() {
    if (this.passwordFieldValue != undefined) {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '';
      }
    }
  }

  passwordFieldValue: any;
  reviewUserFieldValue: any;
  approverUserFieldValue: any;
  reviewAndapproveToggleValue: any;
  reasonFieldValue: any;
  dynamicButtonFieldValidation() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reviewUserFieldValue = document.getElementById('reviewUser-validation') as HTMLInputElement;
    this.approverUserFieldValue = document.getElementById('approverUser-validation') as HTMLInputElement;
    this.reviewAndapproveToggleValue = document.getElementById('reviewAndapprove-validation') as HTMLInputElement;
    this.reasonFieldValue = document.getElementById('reason-validation') as HTMLInputElement;
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '';
      }
    }
    if (this.reviewStatus?.length > 0) {
      if (this.selectedStatus == null) {
        this.reviewAndapproveToggleValue.style.color = 'red';
      } else {
        this.reviewAndapproveToggleValue.style.color = '';
      }
      if (this.reason == '' || this.reason == undefined || this.reason == null) {
        this.reasonFieldValue.style.color = 'red';
      } else {
        this.reasonFieldValue.style.color = '';
      }
    }
  }
  confirmWithReasonFunc() {
    this.isProcessing = true;
    if ((this.password == '' && localStorage.getItem("adEnabled") != 'Y') ||
      ((this.buttonLabel == 'Review' || this.buttonLabel == 'Approve' || this.buttonLabel == 'Reject Response' ||
        this.buttonLabel == 'Accept Response/No Implementation Required' || this.buttonLabel == 'Accept Response' || this.buttonLabel == 'Reject Implementation' ||
        this.buttonLabel == 'Accept Implementation' || this.buttonLabel == 'verify Response' || this.buttonLabel === 'verify implementation')
        && (this.reason == "" || this.reason == null))) {
      this.dynamicButtonFieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      let datavalidation = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(datavalidation).subscribe((data1: any) => {
        if (data1.resultType == "S") { /* empty */ } else {
          this.isProcessing = false;
          this.showSnackBar(data1.result, data1.resultType);
        }
      })
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  backbtn() {
    if (this.qmsservice.moduleName == 'CR') {
      this.router.navigate(['dashboard/qmsCr']);
    } else if (this.qmsservice.moduleName == 'CAPA') {
      this.router.navigate(['dashboard/capa']);
    } else if (this.qmsservice.moduleName == 'DV') {
      this.router.navigate(['dashboard/dv']);
    } else if (this.qmsservice.moduleName == 'IN') {
      this.router.navigate(['dashboard/in']);
    } else if (this.qmsservice.moduleName == 'QI') {

      this.router.navigate(['dashboard/qi']);
    } else if (this.qmsservice.moduleName == 'CC') {
      this.router.navigate(['dashboard/cc']);
    } else if (this.qmsservice.moduleName == 'AU') {
      this.qmsservice.moduleName = "AU";
      this.qmsservice.activityId = this.message.activityId;
      if (this.auService.auditPageFrom == 'MyTask') {
        this.auService.auditPageFrom = 'MyTask';
      } else {
        this.auService.auditPageFrom = 'Main';
      }
      this.router.navigate(['dashboard/auDetailPage']);
    } else if (this.qmsservice.moduleName == 'OOS') {
      this.router.navigate(['dashboard/qmsOOS']);
    }
  }

  actionStatus: any;
  comments: any;
  rejectReason: any;
  isConfirmationFileValid = false;
  statusList: CodeList[] = [];
  rejectReasonList: CodeList[] = [];
  reasonForSignatureList: any = [];
  statusDropdown: any = [];
  reasonDropdown: any = [];
  rejectReasonDropdown: any = [];

  selectedReason: any = [];
  selectedRejectReason: any = [];

  selectedCategoryValue: any = "";
  selectedTrainingTypeValue: any = "";
  selectedLanguageValue: any = "";
  selectedRejectReasonValue: any = "";
  selectedStatusValue: any = "";
  selectedReasonValue: any = "";
  isShowRejectReason = false;

  status: any;
  pass: any;

  buttonListWithoutStages: any;
  statusRequiredMsg: any;
  passRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  allStatus: any = [];
  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  fileExtn: any;
  buttonOperationFile: any;
  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "QMS");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.isConfirmationFileValid = true;

          } else {
            this.isConfirmationFileValid = false;
            this.showSnackBar(data.result, data.resultType);
          }
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  };

  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  confirmWithDataPopupConfig = {
    width: '750px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  title: any;
  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;
  confirmPopupConfig = {
    width: this.qmsservice.moduleName == 'QI' && this.qmsservice.activity.seriousBreachAssessmentFormRequired ? '600px' : '525px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  dynamicButtonClick1(button: string) {
    this.title = button;
    this.buttonLabel = button;
    if (button == "Cancel") {
      this.backbtn();
    } else if (button == "Save") {
      this.editworkflowDetail();
    } else if (button == "Review" || button == "Approve" || button == "Reject" || button == 'Peer Review') {
      this.password = "";
      this.comments = "";
      this.statusDropdown = [];
      this.rejectReasonDropdown = [];
      this.selectedReason = [];
      this.selectedStatus = null;
      this.selectedRejectReason = [];
      this.selectedReasonValue = "";
      this.selectedStatusValue = "";
      this.selectedRejectReasonValue = "";
      this.reasonDropdown = [];
      this.allStatus = [];
      let data1 = [];
      this.isEsignRequired = true;
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
        this.allStatus = this.actionStatusOptions.split(",");
        for (let k = 0; k < this.allStatus.length; k++) {
          this.allStatus[k] = this.allStatus[k].trim();
        }
      }
      this.statusList = [];
      for (let i = 0; i < data1.length; i++) {
        console.log(data1[i][0] == '/s/g');
        data1[i] = data1[i].trim();
        let data2 = data1[i].split("/");
        if (data2.length > 1) {
          this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
        } else {
          this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
        }
      }
      for (const element of this.statusList) {
        this.statusDropdown = this.statusDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
      this.isProcessing = true;
      const rejectReasonKey = this.qmsservice.moduleName === 'IN' ? 'INCIDENT_REJECT_REASON' : this.qmsservice.moduleName + '_REJECT_REASON';
      this.appService.getCodeListsByGroup(rejectReasonKey).subscribe((data: any) => {
        this.rejectReasonList = data;
        this.isProcessing = false;
        for (const element of this.rejectReasonList) {
          this.rejectReasonDropdown = this.rejectReasonDropdown.concat({
            valueExp: element.codelistCode,
            displayExp: element.codelistName
          });
        }
      })
      this.isProcessing = true;

      this.isEsignRequired = true;
      this.changetypeAddAndEditPassword = true;
      this.buttonOperationFile = null;
      this.fileExtn = '';
      this.userName = localStorage.getItem("loggedUserName");
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else {
      this.isReasonSignReqd = false;
      this.selectedStatusValue = null;
      this.comments = "";
      this.selectedRejectReasonValue = null;
      this.selectedReasonValue = "";
      this.buttonLabel = button;
      this.isEsignRequired = false;
      this.userName = localStorage.getItem("loggedUserName");
      this.isEsignRequired = true;
      this.title = button;
      this.password = "";
      this.changetypeAddAndEditPassword = true;
      this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
    }
  };

  onStatusSelect(item: any) {
    this.selectedStatusValue = item.value;
    for (const element of this.allStatus) {
      if (element.includes(item.value)) {
        let value: any = "";
        if (element.includes("/")) {
          const value1 = element.split("/");
          value = value1[0];
        } else {
          value = element;
        }
        this.statusChanges(value);
      }
    }

  }

  statusFiledValue: any;
  rejectReasonFieldValue: any;
  reasonForSignatureFieldValue: any;
  commentsFieldValue: any;
  buttonOperationFieldValidation() {
    this.statusFiledValue = document.getElementById('status-validation') as HTMLInputElement;
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reasonForSignatureFieldValue = document.getElementById('reasonForSignature-validation') as HTMLInputElement;
    this.commentsFieldValue = document.getElementById('comment-validation') as HTMLInputElement;
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '';
      }
    }
    if (this.statusDropdown.length > 0) {
      if (this.selectedStatus == null) {
        this.statusFiledValue.style.color = 'red';
      } else {
        this.statusFiledValue.style.color = '';
        if (this.selectedStatus == "Review Rejected" || this.selectedStatus == "Approval Rejected") {
          if (this.selectedRejectReason.length == 0) {
            if (this.rejectReasonFieldValue) {
              this.rejectReasonFieldValue.style.color = 'red';
            }

          } else if (this.rejectReasonFieldValue) {
            this.rejectReasonFieldValue.style.color = '';
          }
        }
      }
    }

    if (this.selectedReason.length == 0) {
      if (this.reasonForSignatureFieldValue != null) {
        if (this.reasonForSignatureFieldValue) {
          this.reasonForSignatureFieldValue.style.color = 'red';
        }

      }
    } else if (this.reasonForSignatureFieldValue) {
      this.reasonForSignatureFieldValue.style.color = '';
    }

    if (this.comments == null || this.comments == "") {
      if (this.commentsFieldValue != null) {
        this.commentsFieldValue.style.color = 'red';
      }
    } else {
      this.commentsFieldValue.style.color = '';
    }

  }
  reasonForSignature: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = [];
    this.selectedReasonValue = "";
    this.isProcessing = true;
    let data = {
      stageName: this.stageName,
      status: status,
      module: this.qmsservice.moduleName,
    }

    this.appService.getReasonForSigns(data).subscribe((data: any) => {
      this.isProcessing = false;
      this.reasonForSignatureList = data;
      for (const element of this.reasonForSignatureList) {
        this.reasonDropdown = this.reasonDropdown.concat({
          valueExp: element.reasonForSignature,
          displayExp: element.reasonForSignature
        });
      }
      if (this.reasonForSignatureList.length == 1) {
        this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

        this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
        for (const element of this.reasonDropdown) {
          if (element.valueExp == this.reasonForSignatureList[0].reasonForSignature) {
            this.selectedReason = [{
              valueExp: element.valueExp,
              displayExp: element.displayExp
            }]
          }
        }
      }

      if (this.selectedReason.length != 0) {
        if (this.reasonForSignatureFieldValue != undefined) {
          this.reasonForSignatureFieldValue.style.color = '';
        }
      }

    })
  }
  onRejectReasonSelect(item: any) {
    this.selectedRejectReasonValue = item.valueExp;
  }

  onReasonSelect(item: any) {
    this.selectedReasonValue = item.valueExp;
    if (this.reasonForSignatureFieldValue != undefined) {
      this.reasonForSignatureFieldValue.style.color = '';
    }
  }

  onReasonRemoved(item: any) {
    this.selectedReasonValue = "";
    if (this.reasonForSignatureFieldValue != undefined) {
      this.reasonForSignatureFieldValue.style.color = 'red';
    }
  };

  confirmWithDataFunc() {
    this.isProcessing = true;
    let list = [];
    if (this.orgData.allowedFileExtns) {
      list = this.orgData.allowedFileExtns.split(",");
    };
    if (!list.includes(this.fileExtn.toUpperCase()) && this.buttonOperationFile != null) {
      this.isProcessing = false;
      this.showSnackBar("File extension " + this.fileExtn + " is not allowed.", "E");
    } else if ((localStorage.getItem("adEnabled") != 'Y' && this.password == "") || this.comments == "") {
      this.buttonOperationFieldValidation();
      this.showSnackBar("Please enter the all mandatory fields...", "E");
      this.isProcessing = false;
    } else if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      if ((this.selectedReasonValue == "Review Rejected" || this.selectedStatusValue == "Approval Rejected") && (this.comments == null || this.comments == "")) {
        this.buttonOperationFieldValidation();
        alert('Please enter the all mandatory fields...');
        this.isProcessing = false;
      } else {
        this.authEnable("confirmWithDataFunc");

      }

    } else if (this.isEsignRequired && localStorage.getItem("adEnabled") != 'Y') {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          if ((this.selectedReasonValue == "Review Rejected" || this.selectedStatusValue == "Approval Rejected") && (this.comments == null || this.comments == "")) {
            this.buttonOperationFieldValidation();
            alert('Please enter the all mandatory fields...');
            this.isProcessing = false;
          } else {
            let data = {
              workflowId: this.parallelWorkflowData.workflowId,
              currentStatus: this.parallelWorkflowData.status,
              stageName: this.stageName,
              buttonValue: this.buttonLabel,
              actionStatus: this.selectedStatusValue,
              comments: this.comments,
              rejectReason: this.selectedRejectReasonValue,
              reasonForSignature: this.selectedReasonValue,
              fileExtn: this.fileExtn
            }
            const formData = new FormData();
            formData.append('file', this.buttonOperationFile);
            const json = JSON.stringify(data);
            const blob = new Blob([json], {
              type: 'application/json'
            });
            formData.append('object', blob);
            this.appService.performWorkflowButtonOperation(formData).subscribe((Response: any) => {
              this.isProcessing = false;
              if (Response.resultType == "S") {
                this.visibleConfirmWithData.close();
                this.isProcessing = true;
                this.ngOnInit();
              }
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            })
          }
        } else {
          this.showSnackBar(data.result, data.resultType);
          this.isProcessing = false;
        }
      })
    } else {
      this.isProcessing = true;
      if ((this.selectedReasonValue == "Review Rejected" || this.selectedStatusValue == "Approval Rejected") && (this.comments == null || this.comments == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          workflowId: this.parallelWorkflowData.workflowId,
          currentStatus: this.parallelWorkflowData.status,
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn
        }
        const formData = new FormData();
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.appService.performWorkflowButtonOperation(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleConfirmWithData.close();
            this.isProcessing = true;
            this.ngOnInit();
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        })
      }
    }
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }
  cancelConfirmFunc() {
    this.visibleConfirm.close();
  };

  confirmOkFuncSuccessPart(formData: FormData, sectin: string) {
    this.appService.performWorkflowButtonOperation(formData).subscribe((Response: any) => {

      this.isProcessing = false;
      this.showSnackBar(Response.result, Response.resultType);
      if (Response.resultType == "S") {
        this.ngOnInit();
        if (sectin == "confirmWithDataFunc") {
          this.visibleConfirmWithData.close();
        } else if (sectin == "confirmOkFunc") {
          this.visibleConfirm.close();
          this.buttonLabel == 'Delete' && (this.backbtn());
        } else if (sectin == "confirmWithReasonFunc") {
          this.visibleConfirmWithReason.close();
        }
        this.qmsservice.refereshBreadCrumb = false;

      }
      this.isProcessing = false;
    })
  }
  confirmOkFunc() {

    if (((this.isEsignRequired && this.password == '') || (this.comments == "" || this.comments == null)) && localStorage.getItem("adEnabled") != 'Y') {
      this.dynamicButtonFieldValidation();
      alert('Please enter the mandatory field...');
    } else if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("confirmWithReasonFunc");
    } else {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          let data = {
            workflowId: this.parallelWorkflowData.workflowId,
            currentStatus: this.parallelWorkflowData.status,
            stageName: this.buttonLabel == 'Delete' ? 'Delete' : this.stageName,
            buttonValue: this.buttonLabel,
            actionStatus: this.selectedStatusValue,
            comments: this.comments,
            rejectReason: this.selectedRejectReasonValue,
            reasonForSignature: this.selectedReasonValue,
            fileExtn: this.fileExtn
          }
          const formData = new FormData();
          formData.append('file', this.buttonOperationFile);
          const json = JSON.stringify(data);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          formData.append('object', blob);

          this.confirmOkFuncSuccessPart(formData, "confirmOkFunc");

        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      })
    }
  }

  authEnable(flag: string) {
    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            if (flag == 'confirmWithReasonFunc') {
              let data = {
                workflowId: this.parallelWorkflowData.workflowId,
                currentStatus: this.parallelWorkflowData.status,
                stageName: this.buttonLabel == 'Delete' ? 'Delete' : this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);

              this.confirmOkFuncSuccessPart(formData, "confirmOkFunc");
            } else {
              let data = {
                workflowId: this.parallelWorkflowData.workflowId,
                currentStatus: this.parallelWorkflowData.status,
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.appService.performWorkflowButtonOperation(formData).subscribe((Response: any) => {
                this.isProcessing = false;
                if (Response.resultType == "S") {
                  this.visibleConfirmWithData.close();
                  this.isProcessing = true;
                  this.ngOnInit();
                }
                this.showSnackBar(Response.result, Response.resultType);
                this.isProcessing = false;
              })
            }

          } else {
            console.log();
          }

        },
        error: (error: any) => {
          throw error;
        }
      });
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }
}
